import React, { useEffect, useRef, useState } from 'react';
import card1 from '../../../assets/cashier/images/card-img.svg';
import card2 from '../../../assets/cashier/images/card2-img.svg';
import PayIcon from '../../../assets/cashier/images/pay-img.svg';
import visa from '../../../assets/cashier/images/card.png';


import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { detail, payByCash, PaymentMethodList, transactionDetail, splitBilling } from '../services/table.services';
import { CASHIER_ORDER_FLOW_TYPES, LOADER_TIMEOUT_TIME, NO_CARD_SELECTED, NO_OTHER_PAYMENT_SELECTED, PAYMENT_METHOD_TYPES, ROLE, SWAL_SETTINGS } from '../../../utils/Constants';
import RecordNotFound from '../../restaurant/shared/recordNotFound';
import { useTranslation } from 'react-i18next';
import Swal from "sweetalert2";
import { capitalizeFirstLetter, DT, getLocalKey, getSubTotalQRApp, handleServerValidations, showPrice, TrimText } from '../../../utils/commonfunction';
import { calculateEditSalesTotals, getCombinedOrderItems } from '../utils/editSalesTotals';
import { useSelector } from 'react-redux';
import { buildSplitItemPayload } from './dashboard/shared/cashier-home-layout/hooks/splitItemIdentity.ts';
import {publishDisplayEvent} from '../shared/customer-display/customerDisplayClient';
import {useCustomerDisplay} from '../shared/customer-display/useCustomerDisplay';

export default function PaymentViaCash() {
  const location = useLocation();
  const {
    splitItems,
    splitPriceDetail,
    isSplitPayment,
    unique_payment_id,
    order_id,
    splitType = "items",
    splitAmountMode = "manual",
    splitPeopleCount = 0,
    splitAmount = 0,
    splitCouponCode = null,
    splitGiftCardAmount = 0,
  } = location.state || {};
  const [amountReceived, setAmountReceived] = useState(0);
  const [creditCardPaymentMethod, setCreditCardPaymentMethod] = useState([]);
  const [otherPaymentMethod, setOtherPaymentMethod] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const amountReceivedRef = useRef(null);
  const [tableDetail, setTableDetail] = useState({});
  const params = useParams();
  const [orderPriceDetail, setOrderPriceDetail] = useState(null);
  const restaurantData = getLocalKey(ROLE.CASHIER) ? JSON.parse(getLocalKey(ROLE.CASHIER)) : {};
  const cashierData = getLocalKey('cashierDetail') ? JSON.parse(getLocalKey('cashierDetail')) : {};
  const [couponCodeApplied, setCouponCodeApplied] = useState(false);
  const [giftCardApplied, setGiftCardApplied] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedPaymentMethod , setSelectedPaymentMethod]= useState("");
  const [selectedPaymentMethodDetail , setSelectedPaymentMethodDetail] = useState(null);
  const closeModalFirst = useRef();
  const closeModal = useRef();
  const restSettingDetails = useSelector((state) => state?.restSettings?.data);
  const  payByOther = useRef();
  const  payByCard = useRef();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [splitOnlyMode, setSplitOnlyMode] = useState(false);
  const getExpectedAmount = () => Number((giftCardApplied || couponCodeApplied) ? orderPriceDetail?.amount_after_discount : orderPriceDetail?.great_grand_total) || 0;
  const getPaymentDueAmount = () => Math.round(getExpectedAmount());
  const normalizeCashAmount = (value) => Math.round(Number(value) || 0);
  useCustomerDisplay({
    type: 'payment',
    total: getExpectedAmount(),
    paid: 0,
    remaining: getPaymentDueAmount(),
    tendered: normalizeCashAmount(amountReceived),
  });

const keypadButtons = [
  '1', '2', '3',
  '4', '5', '6',
  '7', '8', '9',
  '0', '00', 'C'
];




  const getTableDetail = (tableId) => {
 
    if(type==='edit-sales'){
      transactionDetail({ o_id: tableId }).then((response)=>{
        // console.log(response.data.orderDetail)
        setTableDetail({...response?.data?.orderDetail ,table_id : response?.data?.table_id });
       

        if (response?.data?.orderDetail?.gift_card_applied) {
          setGiftCardApplied(true);
        }
        if (response?.data?.orderDetail?.coupon_code_applied) {
          setCouponCodeApplied(true);
        }
        handelOrderCalculations(response?.data?.orderDetail);

      }).catch((err)=>{
        console.log(err)
      })

    }
    else{
      detail({ o_id: tableId })
      .then((response) => {
        setTableDetail(response?.data);
        setSplitOnlyMode(!!response?.data?.activeOrder?.has_split_payment);
        if(!response.data.activeOrder){
          Swal.fire({
            icon: "error",
            text: 
              t("msg_order_already_billed")
            ,
            ...SWAL_SETTINGS,
          });
          navigate('/cashier/dashboard')

        }
        if (response?.data?.is_available === false) {
          if (response?.data?.activeOrder?.has_split_payment && !isSplitPayment) {
            Swal.fire({
              icon: "error",
              text: "This order is already in split payment. Continue from Split Pay.",
              ...SWAL_SETTINGS,
            });
            navigate(-1);
            return;
          }

          const combinedOrderedItems = [...response?.data?.activeOrder?.ordered_items];
          response?.data?.activeOrder?.subOrders.forEach(subOrder => {
            combinedOrderedItems.push(...subOrder.ordered_items);
          });
          if (response?.data?.activeOrder?.gift_card_applied) {
            setGiftCardApplied(true);
          }
          if (response?.data?.activeOrder?.coupon_code_applied) {
            setCouponCodeApplied(true);
          }
          handelOrderCalculations(response?.data?.activeOrder);
        }
      })
      .catch((err) => {
        console.error(err);
      });
      
    }

  }


  const handelOrderCalculations = (orderDetail, coupon_code_applied) => {
    if (!orderDetail) {
      setOrderPriceDetail({
        subtotal: 0,
        tax_price: 0,
        grand_total: 0,
        total_tax_8: 0,
        total_tax_10: 0,
        service_charge: 0,
        great_grand_total: 0,
        amount_after_discount: 0,
      });
      return;
    }

    // Use the same authoritative totals calculation as the backend's
    // `calculateOrderTotals` (via `calculateEditSalesTotals` which mirrors
    // its rounding contract). Summing the already-rounded stored
    // `subtotal`/`tax_price`/`service_charge` from the base order +
    // sub-orders produces a "sum-after-round" value that can disagree
    // with the "round-after-sum" value used everywhere else, which is
    // what was causing the 1-yen discrepancy between the table details
    // and the payment screen.
    const combinedItems = getCombinedOrderItems(orderDetail);

    const calculated = calculateEditSalesTotals(
      combinedItems,
      orderDetail,
      restSettingDetails
    );

    const data = {
      ...calculated,
      coupon_code_applied,
      coupon_discount: orderDetail?.coupon_discount,
      coupon_type: orderDetail?.coupon_type,
      coupon_code_amount: orderDetail?.coupon_code_amount,
    };

    setOrderPriceDetail(data);
  };

  useEffect(() => {
    if (params.tableId) {
      if (isSplitPayment && splitPriceDetail) {
        setOrderPriceDetail(splitPriceDetail);
        setGiftCardApplied(Number(splitPriceDetail?.gift_card_amount || 0) > 0);
        setCouponCodeApplied(Number(splitPriceDetail?.coupon_code_amount || 0) > 0);
        setSplitOnlyMode(true);
      } else {
        getTableDetail(params.tableId);
      }
    }
  }, [params.tableId]);

  const handleKeypadClick = (value) => {
    console.log(value, "button value");
  
    if (value === 'C') {
      setAmountReceived(0);
    } else if (value === '.' && String(amountReceived).includes('.')) {
      // Prevent multiple decimal points
      return;
    } else {
      setAmountReceived((prev) => {
        const newValue = prev === 0 ? String(value) : String(prev) + value;
        return newValue;
      });
    }
  };
  const keyboardHandleMouseDown = (event) => {
    event?.target?.classList?.add('active');
  };
  const keyboardHandleMouseUp = (event) => {
    event?.target?.classList?.remove('active');
  };


  useEffect(() => {
    PaymentMethodList({ global_search: PAYMENT_METHOD_TYPES.CREDIT_CARD }).then((response) => {
      setCreditCardPaymentMethod(response.data.list);
    }).catch((err) => {
      console.error(err)
    })
    PaymentMethodList({ global_search: PAYMENT_METHOD_TYPES.QR_PAYMENTS }).then((response) => {
      setOtherPaymentMethod(response.data.list);
    }).catch((err) => {
      console.error(err)
    })
  }, []);

  useEffect(() => {
    const element = amountReceivedRef.current;
    if (element) {
      const adjustFontSize = () => {
        element.classList.remove(
          'font-size-30px',
          'font-size-25px',
          'font-size-20px',
          'font-size-15px',
          'font-size-12px'
        );
        if (element.scrollWidth > 200) {
          element.classList.add('font-size-12px');
        } else if (element.scrollWidth > 150) {
          element.classList.add('font-size-15px');
        } else if (element.scrollWidth > 100) {
          element.classList.add('font-size-20px');
        } else if (element.scrollWidth > 50) {
          element.classList.add('font-size-25px');
        } else {
          element.classList.add('font-size-30px');
        }
      };

      adjustFontSize();
      window.addEventListener('resize', adjustFontSize);
      return () => {
        window.removeEventListener('resize', adjustFontSize);
      };
    }
  }, [amountReceived]);



  const handlePayment = (item) => {
  
  
    let newAmountReceived = 0;
  
    if (item && Object.keys(item).length > 0) {
      setSelectedPaymentMethod(item._id);
    
      newAmountReceived = getPaymentDueAmount();
  
     setAmountReceived(newAmountReceived); // Asynchronous update
  
     closeModalFirst.current.click();
     closeModal.current.click();


    }

    else{
      newAmountReceived = amountReceived;
    }

    if(Number(newAmountReceived)===0){
      newAmountReceived = getPaymentDueAmount() || orderPriceDetail?.grand_total;
    }

    const receivedAmount = normalizeCashAmount(newAmountReceived);
    const dueAmount = getPaymentDueAmount();

  if (receivedAmount < dueAmount) {
    console.log("got toast")
      Swal.fire({
        icon: "error",
        text: DT(
          t("msg_amount_not_equal_total"),
          [
            showPrice(receivedAmount),
            showPrice(dueAmount)
          ]
        ),
        ...SWAL_SETTINGS,
      });
      return;
    }
  
  
    else{
      let obj = {
        subtotal: orderPriceDetail?.subtotal,
        tax_price: orderPriceDetail?.tax_price,
        total_tax_8: orderPriceDetail?.total_tax_8,
        total_tax_10: orderPriceDetail?.total_tax_10,
        grand_total: orderPriceDetail?.grand_total,
        great_grand_total: orderPriceDetail?.great_grand_total,
        service_charge: orderPriceDetail?.service_charge,
        received_amount: receivedAmount,
        table_id: type==='edit-sales' ?tableDetail.table_id : params?.tableId,
        cashier_id: cashierData?._id,
        order_id:type==='edit-sales' ? tableDetail?._id :tableDetail?.activeOrder?._id,
        giftCardApplied: giftCardApplied,
        couponCodeApplied: couponCodeApplied,
        amount_after_discount: dueAmount,
        gift_card_amount: orderPriceDetail?.gift_card_amount,
        coupon_code_amount: orderPriceDetail?.coupon_code_amount,
        coupon_code: tableDetail?.activeOrder?.coupon_code || tableDetail?.coupon_code,
        // The cashier's snapshot of the order's gross total (subtotal +
        // tax + service charge). The backend recomputes this inside
        // its Mongo transaction and rejects the payment if the live
        // total has moved (e.g. a waiter added a new sub-order
        // between the cashier loading the screen and clicking Pay).
        // This is the tripwire that prevents a concurrent sub-order
        // from being billed but excluded from the payment total.
        expected_order_total: orderPriceDetail?.great_grand_total,
      };
  
       if (item?.payment_method_type === "credit_card") {
          obj.payment_method = "card";
          obj.method_name = item.payment_type;
          obj.payment_method_id = item._id;
        
        }
        if (item?.payment_method_type === "qr_payments") {
          obj.payment_method = "other";
          obj.method_name = item.payment_type;
          obj.payment_method_id = item._id;
        
        }

        if (isSplitPayment) {
          obj.unique_payment_id = unique_payment_id || undefined;
          obj.split_type = splitType;
          obj.split_amount_mode = splitType === "amount" ? splitAmountMode : undefined;
          obj.split_amount = splitType === "amount" ? splitAmount : undefined;
          obj.split_people_count =
            splitType === "amount" && splitAmountMode === "equal"
              ? Number(splitPeopleCount || 0) || undefined
              : undefined;
          // Line discriminators: the backend selects the exact configuration
          // when the same menu item appears at different prices in one order,
          // and rejects the selection outright without them. Keep settlement
          // payload identity in sync with split preview payload identity.
          obj.split_items = splitType === "items"
            ? splitItems.map(item => buildSplitItemPayload(item))
            : undefined;
          obj.coupon_code = splitCouponCode || undefined;
          obj.gift_card_amount = Number(splitGiftCardAmount || 0) || undefined;
          obj.is_split_payment = true;
          obj.order_id = order_id;
          if (!obj.payment_method) {
            obj.payment_method = "cash";
          }
        }
    
        setLoader(true);
        const apiCall = isSplitPayment ? splitBilling(obj) : payByCash(obj);
        apiCall
          .then((response) => {
            if (response.success) {
              setTimeout(() => {
                setLoader(false);
                if (isSplitPayment) {
                  const transactionDetail = response.data?.transaction;
                  const splitPaymentReturnPath = `/cashier/dashboard/categories/${params.tableId}?type=${CASHIER_ORDER_FLOW_TYPES.SPLIT_PAY}`;

                  // Every split payment lands on the success screen, not just
                  // cash ones with change to return — card/other-method splits
                  // were skipping it entirely and bouncing straight back to
                  // dashboard/checkout. handleSuccessExit (PaymentSuccess.js)
                  // uses returnPath to decide where "back"/"home" goes next.
                  navigate(`/cashier/payment-success/${order_id}`, {
                    state: {
                      orderTransactionDetail: transactionDetail,
                      paymentMethod: obj.payment_method,
                      returnPath: response.data?.is_fully_paid
                        ? "/cashier/dashboard"
                        : splitPaymentReturnPath,
                    },
                  });
                } else {
                  navigate(`/cashier/payment-success/${tableDetail?.activeOrder?._id}`, {
                    state: {paymentMethod: obj.payment_method || 'cash'},
                  });
                }
              }, LOADER_TIMEOUT_TIME);
            } else {
              setTimeout(() => {
                setLoader(false);
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }, LOADER_TIMEOUT_TIME);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.error("error--->", error);
          });
      }
  
    };
    
  
  /** Attaching the hardware keyboard with virtual keyboard */
  useEffect(()=>{
    const handleKeyEvents = (event) => {
      if(window.location.pathname?.includes("/cashier/payment-via-cash")){
        const allNumbers = ["0","1","2","3","4","5","6","7","8","9"];
        if(allNumbers.indexOf(event.key)>=0){
          const keyboardElement = document.getElementById(`keyboard-key-${event.key}`);
          if(keyboardElement){
            if(event.type === "keyup"){
              keyboardElement.click();
              keyboardElement.classList.remove("active");
            }else{
              keyboardElement.classList.add("active");
            }
          }
        }else if(event.key === "Backspace" || event.key === "Delete"){
          const keyboardElement = document.getElementById(`keyboard-key-C`);
          if(keyboardElement){
            if(event.type === "keyup"){
              keyboardElement.click();
              keyboardElement.classList.remove("active");
            }else{
              keyboardElement.classList.add("active");
            }
          }
        }
      }
    }
    window.addEventListener('keydown', handleKeyEvents);
    window.addEventListener('keyup', handleKeyEvents);
    return () => {
      window.removeEventListener('keydown', handleKeyEvents);
      window.removeEventListener('keyup', handleKeyEvents);
    };
  },[]);


  const openOtherPaymentModal = () => {
// console.log(amountReceived ,orderPriceDetail.great_grand_total ,orderPriceDetail.amount_after_discount )
let newAmount = 0;
newAmount = amountReceived

// if(Number(amountReceived)===0){

//   if(giftCardApplied || couponCodeApplied){
//     newAmount = Number(orderPriceDetail.amount_after_discount);
//     setAmountReceived(Number(orderPriceDetail.amount_after_discount) )
//   }
//   else{
//     setAmountReceived( Number(orderPriceDetail.great_grand_total))
//     newAmount =  Number(orderPriceDetail.great_grand_total)
//   }
  
// }
if(Number(newAmount)===0) {
  Swal.fire({
    icon: "error",
    text: t("label_amount_not_entered"),
    ...SWAL_SETTINGS,
  });
  return;
}

if (Number(Number(newAmount).toFixed(0)) !== Number(showPrice(Number(getExpectedAmount()).toFixed(0)))) {
      Swal.fire({
        icon: "error",
        text:t("new_msg_amount_not_equal"),
        ...SWAL_SETTINGS,
      });
      return;
    }
    else{
     payByOther.current.click();
    }
  
   
  };

  const openCardModal = () => {
    let newAmount = 0;
    newAmount = amountReceived
    
    // if(Number(amountReceived)===0){
    
    //   if(giftCardApplied || couponCodeApplied){
    //     newAmount = Number(orderPriceDetail.amount_after_discount);
    //     setAmountReceived(Number(orderPriceDetail.amount_after_discount) )
    //   }
    //   else{
    //     setAmountReceived( Number(orderPriceDetail.great_grand_total))
    //     newAmount =  Number(orderPriceDetail.great_grand_total)
    //   }
      
    // }
    if(Number(newAmount)===0) {
      Swal.fire({
        icon: "error",
        text: t("label_amount_not_entered"),
        ...SWAL_SETTINGS,
      });
      return;
    }

    if (Number(Number(newAmount).toFixed(0)) !== Number(showPrice(Number(getExpectedAmount()).toFixed(0)))) {
          Swal.fire({
            icon: "error",
            text: t("new_msg_amount_not_equal"),
            ...SWAL_SETTINGS,
          });
          return;
        }

        else{

          payByCard.current.click();

        }
  
  
  };


  return (
    <div className="dashboard-cashier-wrap amount-to-pay-page">
      {loader && (
        <div className="loader-box">
          <div className="loader-in">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
              <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                <stop offset="0" stop-color="#FFFFFF"></stop>
                <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
              </radialGradient>
              <circle transformOrigin="center" fill="none" stroke="url(#a12)" strokeWidth="15" strokeLinecap="round" strokeDasharray="200 1000" strokeDashoffset="0" cx="100" cy="100" r="70">
                <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
              </circle>
              <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
            </svg>
            <span>{t("label_waiting_payment")} </span>
          </div>
        </div>
      )}
      <div className="cashier-head text-center">
        <h4>{t("payment_label")}</h4>
        <div className="btns-head-in-left" onClick={() => {
          publishDisplayEvent({type: 'idle'}, true);
          navigate("/cashier/dashboard");
        }}>
          <button className="btn btn-icon">
            <i className="ti ti-arrow-left"></i>
          </button>
        </div>
      </div>
      <div className="payment-wraper amount-to-pay-screen">
        <div className="payment-wraper-in">
          <div className="payment-calculator-column">
          <div className="paymnet-typing shadow-box">
            <span>{t("label_total")}</span>
            <h4>¥ {giftCardApplied || couponCodeApplied ? showPrice(orderPriceDetail?.amount_after_discount) : showPrice(orderPriceDetail?.great_grand_total)}</h4>
          </div>
          <div className="payment-keypad-box shadow-box">
            <div className="amount-received-box d-flex align-items-center justify-content-between">
              <h4>{t("label_amt_recieved")}</h4>
              <h5 ref={amountReceivedRef}>¥ {amountReceived}</h5>
            </div>
            <div className="payment-keypad">
              <div className="row">
                {keypadButtons.map((button, index) => (
                  <div className="col-md-4" key={index}>
                    <button
                      disabled={String(amountReceived).length >= 13 && button !== "C"}
                      className="cashier-key-button"
                      id={`keyboard-key-${button}`}
                      onClick={() => handleKeypadClick(button)}
                      onMouseDown={keyboardHandleMouseDown}
                      onMouseUp={keyboardHandleMouseUp}
                    >
                      {button}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          </div>
          <div className="keypad-action-btn-left gap-3">
            {!splitOnlyMode && restSettingDetails?.credit_card_payments_acceptance && (
              <button className="keypad-action-btns" onClick={()=>openOtherPaymentModal()}>
                <img src={card1} alt="other payment" />
                <span>{t("label_pay_via_other")}</span>
              </button>
            )}
            <span className='d-none' data-bs-toggle="modal" data-bs-target="#pay-with-other" ref={payByOther}></span>
            {!splitOnlyMode && restSettingDetails?.qr_code_payments_acceptance && (
              <button className="keypad-action-btns mt-5" onClick={()=>openCardModal()}>
                <img src={card2} alt="card payment" />
                <span>{t("label_pay_via_card")}</span>
              </button>
            )}
              <span className='d-none' data-bs-toggle="modal" data-bs-target="#pay-card-modal" ref={payByCard}></span>
          </div>
          <div className="keypad-action-btn-right gap-3">
            <button className="keypad-action-btns" onClick={() => handlePayment(null)}>
              <img src={PayIcon} alt="cash payment" />
              <span>{splitOnlyMode ? t("label_complete_split_payment") : t("label_pay_via_cash")}</span>
            </button>
          </div>
          <div className="modal fade modal-cashier" id="pay-card-modal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setSelectedPaymentMethod("");
                    }}
                  >
                    <i className="ti ti-arrow-left"></i>
                  </button>
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    {t("label_choose_credit_card")}
                  </h1>
                  <button
                    type="button"
                    className="btn btn-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeModalFirst}
                    onClick={() => {
                      setSelectedPaymentMethod("");
                    }}
                  >
                    <i className="ti ti-x"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="payment-radio">
                    {creditCardPaymentMethod.length ? (
                      <div className="row">
                        {creditCardPaymentMethod.map((item, index) => (
                          <div
                            className="col-md-6"
                            key={index}
                            onClick={() => {
                              handlePayment(item);
                            }}
                          >
                            <div className="payment-radio-card">
                              <input type="radio" id={item.payment_type} name={item.payment_type} checked={selectedPaymentMethod === item?._id} />
                              <img src={item?.method_image} alt="card" />
                              <span>{TrimText(capitalizeFirstLetter(item.payment_type),30)}</span>
                            </div>
                          </div>
                        ))}

                        <div
                          className="col-md-6"
                          onClick={() => {
                            handlePayment(NO_CARD_SELECTED);
                          }}
                        >
                          <div className="payment-radio-card">
                            <input type="radio" id="card_not_selected" name="card_not_selected" checked={selectedPaymentMethod === "card_not_selected"} />
                            <img src={visa} alt="card" />
                            <span>{TrimText(t('label_no_selection'),30)}</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <RecordNotFound heading="no_staff_found" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal fade modal-cashier" id="pay-with-other" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setSelectedPaymentMethod("");
                    }}
                  >
                    <i className="ti ti-arrow-left"></i>
                  </button>
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    {t("label_choose_payment_method")}
                  </h1>
                  <button
                    type="button"
                    className="btn btn-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeModal}
                    onClick={() => {
                      setSelectedPaymentMethod("");
                    }}
                  >
                    <i className="ti ti-x"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="payment-radio payment-method-radio">
                    <div className="payment-radio">
                      {otherPaymentMethod.length ? (
                        <div className="row">
                          {otherPaymentMethod.map((item, index) => (
                            <div
                              className="col-md-6"
                              key={index}
                              onClick={() => {
                                handlePayment(item);
                              }}
                            >
                              <div className="payment-radio-card">
                                <input type="radio" id={item.payment_type} name={item.payment_type} checked={selectedPaymentMethod === item?._id} />
                                <img src={item?.method_image} alt="card" />
                                <span>{TrimText(capitalizeFirstLetter(item.payment_type),30)}</span>
                              </div>
                            </div>
                          ))}
                          <div
                          className="col-md-6"
                          onClick={() => {
                            handlePayment(NO_OTHER_PAYMENT_SELECTED);
                          }}
                        >
                          <div className="payment-radio-card">
                            <input type="radio" id="other_payment_not_selected" name="other_payment_not_selected" checked={selectedPaymentMethod === "other_payment_not_selected"} />
                            <img src={visa} alt="card" />
                            <span>{TrimText(t('label_no_selection'),30)}</span>
                          </div>
                        </div>
                        </div>
                      ) : (
                        <RecordNotFound heading="no_staff_found" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
